import { Tab } from "@mui/icons-material";
import { Box, Button, LinearProgress, Typography } from "@mui/material";
import axios from "axios";
import { User } from "../../utils";
import { useEffect, useState } from "react";
import { hostname, isSafeUrl } from "../../utils";

export default ({
  getToken,
  companyId,
  currentUser,
}: {
  getToken: Function;
  companyId: string;
  currentUser: User;
}) => {
  const [workflowsUrl, setWorkflowsUrl] = useState<string | null>(null);

  const loginUser = async () => {
    const currentToken = await getToken();

    await axios
      .post(
        `${hostname}/workflows/login`,
        { companyId },
        {
          headers: {
            Authorization: `Bearer ${currentToken}`,
          },
        }
      )
      .then((res) => {
        const url = res.data.workflowsUrl;
        if (url) {
          setWorkflowsUrl(url);
        } else {
          console.error("No workflowsUrl returned in the response");
        }
      });
  };

  useEffect(() => {
    if (currentUser.uid) {
      loginUser();
    }
  }, [currentUser]);

  // Automatically open workflows in new tab once URL is ready
  useEffect(() => {
    if (workflowsUrl && isSafeUrl(workflowsUrl)) {
      window.open(workflowsUrl, "_blank")?.focus();
    }
  }, [workflowsUrl]);

  if (!workflowsUrl) {
    return <LinearProgress sx={{ mt: 2 }} />;
  }

  return (
    <Box sx={{ height: "calc(100vh - 220px)", minHeight: "800px" }}>
      <Box
        sx={{
          display: "flex",
          flexWrap: "wrap",
          gap: 1,
          my: 2,
        }}
      >
        <Button
          variant="outlined"
          startIcon={<Tab />}
          onClick={() => {
            if (isSafeUrl(workflowsUrl)) window.open(workflowsUrl, "_blank")?.focus();
          }}
          sx={{
            minWidth: { xs: "100%", sm: "auto" },
          }}
        >
          Open Editor In Tab
        </Button>
      </Box>
      <Box sx={{ textAlign: "center", py: 4 }}>
        <Typography variant="body1" color="text.secondary">
          The workflow editor has been opened in a new tab. Click the button
          above to open it again.
        </Typography>
      </Box>
    </Box>
  );
};
